import { branchesReducers } from "./branches";
import { uiReducers } from "./ui";
import { usersReducers } from "./users";

export const dealerReducers = {
  ...usersReducers,
  ...branchesReducers,
  ...uiReducers,
};
